import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "edit-ticket-content" }
const _hoisted_2 = { class: "edit-ticket-content__badges" }
const _hoisted_3 = { class: "edit-ticket-content__navigation" }

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'

import { getTicketType } from '@/services/tickets.service'
import {
  getPriorityColorLight,
  getStatusColorLight,
  translatedPriority,
  translatedStatus
} from '@/utils/ticketHelpers'

import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import EditTicketContentAttachments from '@/components/features/tickets/EditTicketContentAttachments.vue'
import EditTicketContentLog from '@/components/features/tickets/EditTicketContentLog.vue'
import EditTicketContentOverview from '@/components/features/tickets/EditTicketContentOverview.vue'
import UnderlineTabGroup from '@/design-system/molecules/UnderlineTabGroup.vue'

interface EMITS {
  (e: 'selectedTab', val: string)
}
type BadgeObject = {
  text: string
  type: string
}

type Props = {
  ticketNumber?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditTicketContent',
  props: {
    ticketNumber: {}
  },
  emits: ["selectedTab"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const { locale, t } = useI18n()
const piniaStore = useGeneralStore()
const store = useStore()



const buttons = computed(() => {
  const buttons = [
    {
      text: t('general__text__overview'),
      name: 'overview',
      onClick: () => {
        selectedTab.value = 'overview'
        emits('selectedTab', 'overview')
      }
    },
    {
      text: t('general__text__log'),
      name: 'log',
      onClick: () => {
        selectedTab.value = 'log'
        emits('selectedTab', 'log')
      }
    }
  ]
  if (store.getters.hasFileReaderAccess || store.getters.hasLinkReaderAccess)
    buttons.push({
      text: t('general__text__attachments'),
      name: 'attachments',
      onClick: () => {
        selectedTab.value = 'attachments'
        emits('selectedTab', 'attachments')
      }
    })
  return buttons
})

const badgeTypeText = ref<string>('')
const ticketParent = ref<string | undefined>()
const selectedTab = ref('overview')

const badges = computed<BadgeObject[]>(() => {
  if (!selectedTicket.value) return []
  const badgesArray: BadgeObject[] = []
  if (selectedTicket.value.priority) {
    badgesArray.push({
      text: translatedPriority(selectedTicket.value.priority),
      type: 'priority'
    })
  }
  if (badgeTypeText.value.length) {
    badgesArray.push({
      text: badgeTypeText.value,
      type: 'type'
    })
  }
  if (selectedTicket.value.status) {
    badgesArray.push({
      text: translatedStatus(selectedTicket.value.status),
      type: 'status'
    })
  }
  if (ticketParent.value)
    badgesArray.push({
      text: ticketParent.value,
      type: 'place'
    })
  return badgesArray
})
const selectedTicket = computed(() => piniaStore.selectedTicket)

function getCustomColor(badgeType: string | undefined) {
  switch (badgeType) {
    case 'priority':
      if (!selectedTicket.value?.priority) return undefined
      return getPriorityColorLight(selectedTicket.value?.priority)
    case 'status':
      if (!selectedTicket.value?.status) return undefined
      return getStatusColorLight(selectedTicket.value?.status)
    default:
      return undefined
  }
}
async function setBadgeType(typeId: string) {
  const fullType = await getTicketType(typeId)
  if (fullType) badgeTypeText.value = fullType.name[locale.value]
}

watch(
  selectedTicket,
  async (newValue) => {
    if (newValue) {
      if (newValue.typeId?.length) setBadgeType(newValue.typeId)
      // ticketParent.value =
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(badges.value, (badge, index) => {
        return (_openBlock(), _createBlock(BadgeSquare, {
          key: index,
          badgeText: badge.text,
          customColor: getCustomColor(badge.type),
          grey: badge.type === 'place',
          size: "small"
        }, null, 8, ["badgeText", "customColor", "grey"]))
      }), 128))
    ]),
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(UnderlineTabGroup, {
        buttons: buttons.value,
        selectedName: selectedTab.value
      }, null, 8, ["buttons", "selectedName"]),
      _createElementVNode("p", null, _toDisplayString(_unref(t)('general__data__ticket-number')) + ": " + _toDisplayString(_ctx.ticketNumber ?? '-'), 1)
    ]),
    _withDirectives(_createVNode(EditTicketContentOverview, null, null, 512), [
      [_vShow, selectedTab.value === 'overview']
    ]),
    (selectedTab.value === 'log')
      ? (_openBlock(), _createBlock(EditTicketContentLog, { key: 0 }))
      : _createCommentVNode("", true),
    (selectedTab.value === 'attachments')
      ? (_openBlock(), _createBlock(EditTicketContentAttachments, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})